import { useRemoteConfig } from '@funtech-int/yango-shared';

import { remoteConfigSchema } from '../lib/remoteConfig';

const STARZPLAY = 'starzplay';

export const useStarzplaySelectionIds = () => {
    const remoteConfig = useRemoteConfig(remoteConfigSchema);
    const brandedSelections = remoteConfig.get('branded_selections');
    return brandedSelections?.[STARZPLAY]?.selectionIds ?? [];
};
